<template>
  <div class="flex flex-row w-full">
    <div class="p-1 w-1/3">
      <vs-card class="p-3">
        <!-- <div class="flex flex-row items-center justify-between">
          <h4 class="font-semibold">Export</h4>
          <vs-button color="primary" @click="exportData"> Export </vs-button>
        </div> -->
        <div
          class="flex flex-col items-center justify-between"
          style="gap: 20px">
          <vs-input
            v-model="file_name"
            label="Judul"
            type="text"
            class="w-full" />
          <div class="flex flex-row w-full" style="gap: 20px">
            <div class="w-full">
              <label class="font-normal" for="license_plate">Tipe</label>
              <v-select
                style="background: white"
                placeholder="- Select Event Type -"
                @input="(x) => (event_type = x.value)"
                :clearable="false"
                :value="getSelectValue(event_type, event_list)"
                :reduce="(text) => text.value"
                label="text"
                :options="event_list" />
            </div>
            <!-- <div class="w-full">
              <label class="font-normal" for="license_plate">Format</label>
              <v-select
                style="background: white"
                placeholder="- Select Event Type -"
                @input="(x) => (file_format = x.value)"
                :clearable="false"
                :value="getSelectValue(file_format, format_list)"
                :reduce="(text) => text.value"
                label="text"
                :options="format_list" />
            </div> -->
          </div>
          <div class="w-full">
            <label class="font-normal" for="license_plate">Filter</label>
            <v-select
              @input="(x) => (selected_filter = x.value)"
              placeholder="- Select Filter -"
              :clearable="false"
              :value="getSelectValue(selected_filter, pilih_filter)"
              :reduce="(text) => text.value"
              label="text"
              :options="pilih_filter" />
          </div>
          <div class="w-full" v-if="selected_filter == 'fleet_group'">
            <label class="font-normal" for="fleet_group">Fleet Group</label>
            <v-select
              class="drop-height-auto"
              multiple
              placeholder="- Select Fleet Groups -"
              :clearable="true"
              v-model="fleet_group_id"
              label="text"
              :options="fleet_array" />
          </div>
          <div class="w-full" v-if="selected_filter == 'license_plate'">
            <label class="font-normal" for="license_plate">License Plate</label>
            <v-select
              class="drop-height-auto"
              multiple
              placeholder="- Select License Plates -"
              :clearable="true"
              v-model="license_plate"
              label="text"
              :options="plate_array" />
          </div>
          <div class="flex flex-row w-full items-center" style="gap: 20px">
            <h6 class="w-1/2">Dari tanggal<sup class="text-danger">*</sup></h6>
            <VueCtkDateTimePicker
              no-button-now
              noClearButton
              label="Select Start Date"
              format="YYYY-MM-DD HH:mm"
              v-model="dateStart"
              :min-date="minStart"
              :max-date="maxStart" />
          </div>
          <div class="flex flex-row w-full items-center" style="gap: 20px">
            <h6 class="w-1/2">
              Hingga tanggal<sup class="text-danger">*</sup>
            </h6>
            <VueCtkDateTimePicker
              no-button-now
              noClearButton
              label="Select End Date"
              format="YYYY-MM-DD HH:mm"
              v-model="dateEnd"
              :min-date="dateStart"
              :max-date="maxEnd" />
          </div>
          <div class="flex flex-col w-full" style="gap: 10px">
            <div class="flex flex-row" style="gap: 10px">
              <vs-switch color="danger" v-model="is_email"></vs-switch>
              <h6 class="w-full text-left">
                Kirim Ke
                <span>(Opsional)</span>
                <!-- <sup class="text-danger">*</sup> -->
              </h6>
            </div>
            <!-- whatsapp -->
            <div class="w-full hidden">
              <div
                class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                <label class="vs-input--label">Whatsapp</label>
                <div class="vs-con-input">
                  <div class="flex flex-row w-full" style="gap: 5px">
                    <input
                      type="text"
                      @input="validatePhoneNumber"
                      v-model="phone"
                      name="phone"
                      class="vs-inputx vs-input--input normal"
                      style="border: 1px solid rgba(0, 0, 0, 0.2)" />
                    <vs-button
                      color="danger"
                      type="filled"
                      @click="pushPhone"
                      :disabled="this.phone == '' || this.phoneError !== null"
                      >+</vs-button
                    >
                  </div>
                  <p v-if="phoneError" class="text-xs" style="color: red">
                    {{ phoneError }}
                  </p>
                </div>
                <span></span>
              </div>
              <div class="flex flex-row flex-wrap w-full">
                <div
                  class="w-full sm:w-1/2 p-1"
                  v-for="(item, index) in phone_array"
                  :key="index">
                  <div
                    class="flex flex-row rounded-lg text-white font-semibold">
                    <vs-button
                      class="rounded-r-none p-2 w-full font-semibold"
                      color="danger"
                      type="border"
                      @click="updatePhone(index)"
                      >{{ item }}</vs-button
                    >
                    <vs-button
                      class="rounded-l-none p-2"
                      color="danger"
                      @click="deletePhone(index)"
                      >X</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Email -->
            <div class="w-full">
              <div
                class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                <label class="vs-input--label">Email</label>
                <div class="vs-con-input">
                  <div class="flex flex-row w-full" style="gap: 5px">
                    <input
                      type="text"
                      @input="validateEmailNumber"
                      :value="$dataLocal.UserData().email"
                      name="email"
                      class="vs-inputx vs-input--input normal"
                      style="border: 1px solid rgba(0, 0, 0, 0.2)"
                      disabled />
                    <!-- <vs-button
                      color="danger"
                      type="filled"
                      @click="pushEmail"
                      :disabled="this.email == '' || this.emailError !== null"
                      >+</vs-button
                    > -->
                  </div>
                  <p v-if="emailError" class="text-xs" style="color: red">
                    {{ emailError }}
                  </p>
                </div>
                <span></span>
              </div>
              <div class="flex flex-row flex-wrap w-full">
                <div
                  class="w-full sm:w-1/2 p-1"
                  v-for="(item, index) in email_array"
                  :key="index">
                  <div
                    class="flex flex-row rounded-lg text-white font-semibold">
                    <vs-button
                      class="rounded-r-none p-2 w-full font-semibold"
                      color="danger"
                      type="border"
                      @click="updateEmail(index)"
                      >{{ item }}</vs-button
                    >
                    <vs-button
                      class="rounded-l-none p-2"
                      color="danger"
                      @click="deleteEmail(index)"
                      >X</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="loading-container" class="w-full"></div>
          <vs-button color="danger" class="w-full mt-1" @click="exportData"
            >Export Data</vs-button
          >
        </div>
      </vs-card>
    </div>
    <div class="w-2/3 text-center">
      <img src="@/assets/images/export_bg.png" alt="bg" />
    </div>
  </div>
</template>

<script>
import * as REPO from '../../repository/index'
import * as moment from 'moment'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      file_name: '',
      file_format: 'xlsx',
      format_list: [
        {
          text: '.XLSX',
          value: 'xlsx',
        },
        {
          text: '.CSV',
          value: 'csv',
        },
        {
          text: '.PDF',
          value: 'pdf',
        },
      ],
      event_type: 'alert_history',
      event_list: [
        // {
        //   text: 'Alert History',
        //   value: 'alert_history',
        // },
        {
          text: 'Urgent Alert',
          value: 'urgent',
        },
        {
          text: 'Summary Alert',
          value: 'summary',
        },
        {
          text: 'Odometer',
          value: 'odometer',
        },
        {
          text: 'Accu Voltage',
          value: 'accu',
        },
        {
          text: 'Fuel Consumption',
          value: 'fuel_consumption',
        },

        {
          text: 'Overspeed',
          value: 'overspeed',
          type: 'summary',
          key: ['OVERSPEED'],
        },
        {
          text: 'Harsh Acceleration',
          value: 'harsh_acc',
          type: 'summary',
          key: ['HARSH_ACC'],
        },
        {
          text: 'Harsh Brake',
          value: 'harsh_brk',
          type: 'summary',
          key: ['HARSH_BRK'],
        },
        {
          text: 'Accident Event',
          value: 'crash',
          type: 'urgent',
          key: ['CRASH'],
        },
        {
          text: 'Geofence In & Out',
          value: 'geo_in_out',
          type: 'urgent',
          key: ['GEO_IN', 'GEO_OUT'],
        },
        {
          text: 'Engine On & Off',
          value: 'engine_on_off',
          type: 'ignition',
          key: ['ENGINE_ON', 'ENGINE_OFF'],
        },
      ],

      selected_filter: 'fleet_group',
      pilih_filter: [
        {
          text: 'Fleet Group',
          value: 'fleet_group',
        },
        {
          text: 'License Plate',
          value: 'license_plate',
        },
      ],
      fleet_group_id: '',
      fleet_array: [],
      license_plate: '',
      plate_array: [],
      exportDataInput: '',
      phone: '',
      phone_array: [],
      phoneError: null,
      email: '',
      email_array: [],
      emailError: null,
      minStart: moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'),
      maxStart: moment().format('YYYY-MM-DD HH:mm:ss'),
      maxEnd: null,
      dateStart: null,
      dateEnd: null,
      data: [],
      is_email: false,
    }
  },
  watch: {
    selected_filter(val) {
      this.fleet_group_id = [
        {
          text: this.$dataLocal.UserData().fleet_group.fleet_group_name,
          value: this.$dataLocal.UserData().id,
        },
      ]
      this.license_plate = ''
    },
    dateStart(val) {
      // set max end date to 7 days from start date but not more than today
      const maxEnd = moment(val).add(23, 'hours').add(59, 'minutes')
      this.maxEnd = !moment().isAfter(maxEnd)
        ? moment().format('YYYY-MM-DD HH:mm:ss')
        : maxEnd.format('YYYY-MM-DD HH:mm:ss')

      setTimeout(() => {
        this.dateEnd = this.maxEnd
      }, 50)
    },
    fleet_group_id(val) {
      const hasAll = this.fleet_group_id.find((x) => x.value == 'all')
      const hasOther = this.fleet_group_id.find((x) => x.value != 'all')
      if (hasAll && hasOther) {
        // remove 'all' value from fleet_group_id
        this.fleet_group_id = this.fleet_group_id.filter(
          (x) => x.value != 'all'
        )
      }
    },
    event_type(val) {
      // if the event_type is odometer / accu / fuel_consumption then makethe pilih_filter to license_plate only else it can do both
      if (
        val == 'odometer' ||
        val == 'accu' ||
        val == 'fuel_consumption' ||
        val == 'engine_on_off'
      ) {
        this.pilih_filter = [
          {
            text: 'License Plate',
            value: 'license_plate',
          },
        ]
        this.selected_filter = 'license_plate'
      } else {
        this.pilih_filter = [
          {
            text: 'Fleet Group',
            value: 'fleet_group',
          },
          {
            text: 'License Plate',
            value: 'license_plate',
          },
        ]
        this.selected_filter = 'fleet_group'
      }
    },
  },
  mounted() {
    const self = this
    this.getFilterData()
    this.fleet_group_id = [
      {
        text: 'All',
        value: 'all',
      },
    ]
    this.fleet_array = [
      {
        text: 'All',
        value: 'all',
      },
    ]
    REPO.getListFleetChield(this.$dataLocal.UserData().id).then((res) => {
      if (res.data.status == 'true') {
        const tmp = res.data.data.map((h) => {
          return {
            text: h.fleet_group_name,
            value: h.id,
          }
        })
        // let arrays = []
        // this.rekursive(tmp, arrays, 0)
        //

        this.fleet_array = [...this.fleet_array, ...tmp]
      }
    })

    // let end_date = moment().format('YYYY-MM-DD HH:mm:ss')
    // this.maxEnd = end_date
    // this.dateEnd = end_date
  },
  methods: {
    getFilterData() {
      this.fleet_group_id = 'all'
      REPO.getFilterClusterLicVin(this.$dataLocal.UserData().id).then((res) => {
        if (res.data.status == 'true') {
          let arrays = res.data.data
          let license_plate = []

          arrays.forEach((x) => {
            let license_plate_f = license_plate.some(
              (g) => g.value == x.vehicle_id
            )
            if (!license_plate_f)
              license_plate.push({ text: x.license_plate, value: x.vehicle_id })
          })
          this.plate_array = [...license_plate]
        } else {
        }
      })
    },
    rekursive(arr, res, counter) {
      arr.forEach((x) => {
        let text = ''
        if (counter > 0) {
          for (let z = 0; z < counter; z++) {
            text = text + '- '
          }
        }
        text = text + (parseInt(counter) + 1) + ' ' + x.fleet_group_name
        let tmp = {
          text: text,
          value: x.id,
        }

        res.push(tmp)
        if (x.all_child.length > 0) {
          let con = counter + 1
          this.rekursive(x.all_child, res, con)
        }
      })
    },
    validatePhoneNumber() {
      const phoneNumberRegex = /^(\+62|62|0)8[1-9]\d{7,10}$/

      if (!phoneNumberRegex.test(this.phone) && this.phone !== '') {
        this.phoneError = 'Invalid phone number format'
      } else {
        this.phoneError = null
      }
    },
    pushPhone() {
      if (this.phone !== '') {
        const spliceNum = this.phone.startsWith('0')
          ? 1
          : this.phone.startsWith('+62')
            ? 3
            : this.phone.startsWith('62')
              ? 2
              : 0
        this.phone = '62' + this.phone.slice(spliceNum)

        this.phone_array.push(this.phone)
        this.phone = ''
      } else {
        this.$toast.error('Phone Number Cannot Be Empty')
      }
    },
    updatePhone(val) {
      if (this.phone !== '') {
        this.$toast.error('Phone Number Field Should Be Empty Before Updating')
      } else {
        this.phone = this.phone_array[val]
        this.phone_array.splice(val, 1)
        this.validatePhoneNumber()
      }
    },
    deletePhone(val) {
      //
      this.phone_array.splice(val, 1)
      //
    },
    validateEmailNumber() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      if (!emailRegex.test(this.email) && this.email !== '') {
        this.emailError = 'Invalid email format'
      } else {
        this.emailError = null
      }
    },
    pushEmail() {
      if (this.email !== '') {
        this.email_array.push(this.email)
        this.email = ''
      } else {
        this.$toast.error('Email Cannot Be Empty')
      }
    },
    updateEmail(val) {
      if (this.email !== '') {
        this.$toast.error('Email Field Should Be Empty Before Updating')
      } else {
        this.email = this.email_array[val]
        this.email_array.splice(val, 1)
        this.validateEmailNumber()
      }
    },
    deleteEmail(val) {
      //
      this.email_array.splice(val, 1)
      //
    },
    exportData() {
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loading-container', {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 1400,
        borderRadius: '10px',
        color: 'rgba(234, 84, 85, 1)',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
        text: {
          style: {
            color: '#999',
            position: 'absolute',
            left: '0',
            top: '30px',
            padding: 0,
            margin: 0,
            transform: null,
          },
          autoStyleContainer: false,
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
        },
      })

      bar.animate(0.3)

      const filename = `${this.file_name}_${this.event_type}(${
        moment(this.dateStart).format('YYYYMMDD') +
        '-' +
        moment(this.dateEnd).format('YYYYMMDD')
      })${this.$dataLocal.UserData().id.split('-')[0]}`

      let param = {
        type: 'all',
        email: this.convertArr(this.email_array),
        // number: this.convertArr(this.phone_array),
        // fleet_group_id: this.convertArr(this.fleet_group_id, true),
        // license_plate: this.convertArr(this.license_plate, true),
        start_date: moment(this.dateStart).format('YYYY-MM-DD HH:mm:ss'),
        end_date: moment(this.dateEnd).format('YYYY-MM-DD HH:mm:ss'),
        title: filename,
      }

      if (this.file_name == '') {
        this.$toast.error('Title Cannot Be Empty')
        bar.destroy()
        return
      }

      if (this.dateStart == null || this.dateEnd == null) {
        this.$toast.error('Date Cannot Be Empty')
        bar.destroy()
        return
      }

      if (this.is_email && this.phone_array.length != 0) {
        param.type = 'all'
      } else if (this.is_email && this.phone_array.length == 0) {
        param.type = 'email'
      } else if (this.email_array.length == 0 && this.phone_array.length != 0) {
        param.type = 'number'
      } else {
        param.type = 'local'
        delete param.email
        // param.type = 'all'
        // this.$toast.error('Email Cannot Be Empty')
        // bar.destroy()
        // return
      }

      //

      if (this.selected_filter == 'fleet_group') {
        const hasAll = this.fleet_group_id.find((x) => x.value == 'all')
        if (hasAll) {
          const fgids = JSON.parse(this.$dataLocal.UserData().fleet_group_ids)
          param.fleet_group_ids = fgids
        } else {
          param.fleet_group_ids = this.convertArr(
            this.fleet_group_id,
            true,
            'value'
          )
          // param.fleet_group_ids = this.fleet_group_id
          delete param.license_plate
        }
      } else if (this.selected_filter == 'license_plate') {
        //
        param.license_plate = this.convertArr(this.license_plate, true, 'text')
        delete param.fleet_group_ids
      } else {
        delete param.fleet_group_ids
        delete param.license_plate
        this.$toast.error('Filter Cannot Be Empty')
      }
      //

      // check if event type in the event list has type or not
      const hasType = this.event_list.find((x) => x.value == this.event_type)

      if (hasType.type) {
        param.file_export = hasType.type
        param.event_types = hasType.key
      } else {
        param.file_export = this.event_type
        param.event_types = JSON.parse(this.getRoleCode())
        // if (this.event_type == 'alert_history') {
        //   param.file_export = 'alert_history'
        // } else if (this.event_type == 'odometer') {
        //   param.file_export = 'odometer'
        // } else if (this.event_type == 'periodic') {
        //   param.file_export = 'periodic'
        // } else {
        //   this.$toast.error('Event Type Cannot Be Empty')
        //   bar.destroy()
        //   return
        // }
      }
      //

      //

      //

      // setTimeout(() => {
      //   bar.destroy()
      // }, 500)

      REPO.exportSender(param)
        .then((res) => {
          bar.animate(1.0)

          //
          if (res.data.status == true) {
            //
            this.$toast.success('Export Data Success')
            this.$router.push('/export/history')
          }
        })
        .catch((err) => {
          this.$toast.error('Problem Exporting Data')
        })
        .finally(() => {
          setTimeout(() => {
            bar.destroy()
          }, 500)
        })
      // this.getDataAlertHistory(param)
    },
    convertArr(arr, isFleetGroup = false, isArrRes = null) {
      let res = ''
      let resArr = []
      if (isArrRes) {
        arr.forEach((x, index) => {
          resArr.push(x[isArrRes])
        })
        return resArr
      }
      if (isFleetGroup) {
        arr.forEach((x, index) => {
          if (index == arr.length - 1) res = res + x.value
          else res = res + x.value + ','
        })
      } else {
        arr.forEach((x, index) => {
          if (index == arr.length - 1) res = res + x
          else res = res + x + ','
        })
      }
      return res
    },
    getDataAlertHistory() {
      var ProgressBar = require('progressbar.js')
      var bar = new ProgressBar.Line('#loading-container', {
        strokeWidth: 1,
        easing: 'easeInOut',
        duration: 1400,
        borderRadius: '10px',
        color: 'rgba(234, 84, 85, 1)',
        trailColor: '#eee',
        trailWidth: 1,
        svgStyle: { width: '100%', height: '100%', borderRadius: '10px' },
        text: {
          style: {
            color: '#999',
            position: 'absolute',
            left: '0',
            top: '30px',
            padding: 0,
            margin: 0,
            transform: null,
          },
          autoStyleContainer: false,
        },
        from: { color: '#FFEA82' },
        to: { color: '#ED6A5A' },
        step: (state, bar) => {
          bar.setText('Collecting Data ' + Math.round(bar.value() * 100) + ' %')
        },
      })

      bar.animate(0.0)

      // this.$vs.loading({
      //   container: '#isi_table',
      //   scale: 1,
      // })
      // this.loadingBtnStart('btn-download')
      const param = {
        limit: -1,
        fleet_group_id: this.selected_fleet,
        start_date: this.dateStart,
        event_type: '',
        end_date: this.dateEnd,
      }

      if (this.event_type == '') delete param.event_type
      if (this.license_plate == '') delete param.license_plate

      REPO.getAlertHistory(param).then(async (res) => {
        let tmp = res.data.data.data
        //

        if (tmp == null || tmp == undefined || tmp.length == 0) {
          // this.$vs.loading.close('#isi_table > .con-vs-loading')
          // this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          // this.loadingBtnStop('btn-download')

          this.$toast.error(`Data is empty!`, {
            duration: 2000,
          })

          bar.destroy()
          return
        }

        const temp = tmp.map((x, index) => {
          bar.animate((index + 1) / tmp.length)
          return {
            'License Plate': x.license_plate,
            'Fleet Group': x.fleet_group_name,
            Alert: x.event_type,
            Speed: x.speed + ' Km/h',
            Date: x.device_time,
            Gmaps: 'Show Google Map',
            Streetview: 'Show Street View',
            'Verified by': x.verified_by ? x.verified_by : 'Unverified',
            Notes: x.note ? x.note : '-',
          }
        })

        const rows = temp
        const worksheet = XLSX.utils.json_to_sheet(rows)
        for (let i = 0; i < rows.length; i++) {
          worksheet[`F${i + 2}`] = {
            v: 'Show Google Map',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/search/?api=1&query=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Google Map',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
          worksheet[`G${i + 2}`] = {
            v: 'Show Street View',
            t: 's',
            l: {
              Target: `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${tmp[i].latitude},${tmp[i].longitude}`,
              Tooltip: 'Show Street View',
            },
            s: {
              font: {
                color: { rgb: '0563C1' },
                underline: true,
              },
            },
          }
        }
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')

        const file_name = this.file_name.replace(/\s/g, '')

        const file_res = XLSX.writeFile(
          workbook,
          `${file_name}.xlsx`,
          // `alert_history_report_${moment().format('YYYY-MM-DD_HHmm')}.xlsx`,
          {
            compression: true,
          }
        )

        // this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        // this.$vs.loading.close('#isi_table > .con-vs-loading')
        // this.loadingBtnStop('btn-download')
        this.load_done = true
        // destroy bar
        bar.destroy()

        // const promises = tmp.map(async (x, index) => {
        //   try {
        //     const result = await this.getAddress(x.latitude, x.longitude)
        //     // Update the address property for each item in the array
        //     x.address = result.display_name
        //     bar.animate((index + 1) / tmp.length)
        //   } catch (err) {
        //     console.error(err)
        //     // Handle errors if needed
        //   }
        // })

        // await Promise.all(promises)
        //   .then(() => {
        //     // Rest of your code remains unchanged
        //     //

        //     const temp = tmp.map((x) => {
        //       return {
        //         'License Plate': x.license_plate,
        //         'Fleet Group': x.fleet_group_name,
        //         Alert: x.event_type,
        //         Speed: x.speed + ' Km/h',
        //         Date: x.device_time,
        //         Location: x.address,
        //         'Verified by': x.verified_by ? x.verified_by : 'Unverified',
        //         Notes: x.note ? x.note : '-',
        //       }
        //     })

        //     const rows = temp
        //     const worksheet = XLSX.utils.json_to_sheet(rows)
        //     const workbook = XLSX.utils.book_new()
        //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Dates')

        //     XLSX.writeFile(
        //       workbook,
        //       `alert_report_${
        //         this.event_type ? this.event_type + '_' : 'all_'
        //       }${moment().format('YYYY-MM-DD_HHmm')}.xlsx`,
        //       {
        //         compression: true,
        //       }
        //     )

        //     this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
        //     this.$vs.loading.close('#isi_table > .con-vs-loading')
        //     this.loadingBtnStop('btn-download')
        //     this.load_done = true
        //     // destroy bar
        //     bar.destroy()
        //   })
        //   .catch((err) => {
        //     // Handle errors if needed
        //   })
      })
    },
  },
}
</script>

<style lang="scss">
.datetimepicker > .flex {
  display: none !important;
}

.visible > .flex {
  display: flex !important;
}
</style>
